import axios from "axios";
import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";

export const JobService = {
  getSoftSkills,
  searchSoftSkill,
  getSkills,
  searchSkill,
  getLanguages,
  searchLanguage,
  getCertifications,
  searchCertification,
  skillVerification,
};

function getSoftSkills() {
  return axiosInterceptors
    .get(ENV.softskills_url + "skillType=SOFT_SKILL&ps=200&&sortOrder=ASC")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function searchSoftSkill(skill) {
  return axiosInterceptors
    .get(ENV.softskills_url + "skillType=SOFT_SKILL&search=" + skill)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getSkills() {
  return axiosInterceptors
    .get(ENV.skills_url + "skillType=SKILL")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function searchSkill(skill) {
  return axiosInterceptors
    .get(ENV.skills_url + "skillType=SKILL&search=" + skill)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getLanguages(sortOrder) {
  return axiosInterceptors
    .get(
      ENV.languages_url + "skillType=LANGUAGE&ps=200&&sortOrder=" + sortOrder
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function searchLanguage(language) {
  return axiosInterceptors
    .get(ENV.languages_url + "skillType=LANGUAGE&search=" + language)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getCertifications() {
  return axiosInterceptors
    .get(ENV.skills_url + "skillType=CERTIFICATION")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function searchCertification(certification) {
  return axiosInterceptors
    .get(ENV.skills_url + "skillType=CERTIFICATION&search=" + certification)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function skillVerification() {
  return axiosInterceptors
    .get(ENV.skillverification_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}
